import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ModalController,NavController,AlertController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { AddImagePage } from '../../../pages/add-image/add-image.page'
@Component({
  selector: 'app-attributes-edit',
  templateUrl: './attributes-edit.component.html',
  styleUrls: ['./attributes-edit.component.scss','../dynamic-form/dynamic-form.component.scss'],
})
export class AttributesEditComponent implements OnInit {
  @Input() product_info;
  @Input() edit_index;
  @Input() edit_info;
  @Input() current_attribute;
  uom:any =[];
  constructor(public alertCtrl: AlertController,public DBservice:DataService,public modalCtrl:ModalController,public navCtrl:NavController) { }

  ngOnInit() {
    // console.log(this.edit_info,'edit info')
    // console.log(this.product_info,'product info')
    if(this.edit_info && this.edit_info.image_list && this.edit_info.image_list.length > 0){
      let check = this.edit_info.image_list.find(obj=> obj.is_primary == 1)
      check ? this.edit_info.image = this.DBservice.product_img(check.image) : ''

      let check_img = this.edit_info.image_list.find(obj=> obj.image_upload == true)
      check_img ? this.edit_info.image = check_img.filedata : ''
    }

    this.get_Uom();
  }

  get_Uom(){
    this.DBservice.get_uom_list().subscribe(res =>{
      console.log(res)
      this.uom = res.data;
    })
  }
 

  async edit_img(page_name,index){
    // this.DBservice.image_page = page_name;
    const modal = await this.modalCtrl.create({
      component: AddImagePage,
      cssClass:'add-image-modal',
      componentProps:{
        product_info : this.product_info,
        product_id : this.product_info.name,
        img_type: 'attribute',
        edit_index: this.edit_index ? this.edit_index - 1 : index
      }
    })
     await modal.present();
     await modal.onWillDismiss().then(res =>{
       setTimeout(() => {   
       if(this.edit_info != undefined){  
         let check_img = this.edit_info.image_list.find(obj=> obj.image_upload == true)
         check_img ? this.edit_info.image = check_img.filedata : ''   
       }
       else{
         let check_img = this.product_info.variant_combination[index].image_list.find(obj=> obj.image_upload == true)
         check_img ? this.product_info.variant_combination[index].image = check_img.filedata : ''
       }
       }, 1000);
        // if(res.data && res.data == 'success'){
          // this.product = this.product;
        // }
    })
     

  }

  pluscount(count) {
    // console.log(count)
    if(count != undefined){
      count = count + 1;
      return count;
    }else{
      count = 0;
      count = count + 1;
      return count;
    }
  }

  edit_combination(data){

  }

  save_data(){
    if(this.edit_index && this.product_info.variant_combination[this.edit_index - 1].weight == 0)
      this.DBservice.auto_close_alert('Please enter the weight');
    else if(!this.edit_index){
      let check = this.product_info.variant_combination.filter(obj => obj.weight == 0)
      if(check && check.length > 0)
        this.DBservice.auto_close_alert('Please enter the weight');
      else
        this.modalCtrl.dismiss();
    }
    else
      this.modalCtrl.dismiss();
  }

  async del_options(data,index,array){
    let alert = await this.alertCtrl.create({
      header: 'Confirm',
      message: 'Do you want to delete the item?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
              if(data.name){
                // this.DBservice.remove_combination({product:data.parent,combination_id:data.name}).subscribe((res:any) => {
                //   if(res.message.status == 'Success')
                //   {
                    this.product_info.variant_combination.splice(index,1)
                    this.modalCtrl.dismiss();
                //   }
                //   // console.log(res)
                // }, error => {
                //  console.log(JSON.stringify(error.json()));
                // });
                
              }else{
                array.splice(index,1);
                this.modalCtrl.dismiss();
              }
          }
        }
      ]
    })
    await alert.present();
     // this.product_info.variant_combination.splice(index,1)
   }

  minus(a) {
    if (a != 0) {
      a = a - 1;
      return a;
    } else {
      return 0;
    }
  }

  current_variant ;
  load_values(data){
   //  this.myform.valueChanges.subscribe(x => {
   //   console.log('form value changed',x)
   // })
    this.current_variant = data
   //  this.load_product_Values(data)
     // this.form_data[0].group_fileds.map(res =>{
     //   res.value = data[res.name] 
     // })
  }

  form_data:any =  [
    {
      group_title : 'VARIANT DETAIL',
      mapped_by: 'variant_detail',
      group_fileds : [
            {
              label :'Option',
              input_type: 'input',
              type : 'text',
              name :'option_value',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            },
            {
              label :'Display Order',
              input_type: 'input',
              type : 'text',
              name : 'display_order',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
            },
            {
              label :'Is Pre Selected',
              input_type: 'checkbox',
              type : 'text',
              name :'is_pre_selected',
              placeholder : '',
              required : false,
              hidden: false,
              value : 0
            },
            {
              label :'Disable',
              input_type: 'checkbox',
              type : 'text',
              name :'price',
              placeholder : '',
              required : true,
              hidden: false,
              value : 0,
            },
      ]
    },
  ]


  getPrice(event:any,variant:any,type:any){

    // console.log(event);

    if(event.target.value){
      let value =  event.target.value;
      // value = value[0] == 0 ? value.substring(1) : value;
      value = Number(value);
      if(typeof(value) == 'string'){
        value = Number(value).toFixed(3);
      }else{
        value = value.toFixed(3);
      }
      variant.weight = value 
      console.log(variant)
    }else{
      variant.weight = 0.00;
    }
  }

  select_value(event:any){
      const inputElement = event.target.querySelector('input') as HTMLInputElement;
      inputElement.select();
  }


}
